/* global fbq */
import React, { useEffect, useState, useCallback, useRef, useMemo, useLayoutEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../HeaderNew/component";
import API2 from "../../api/indexv2";
import { GET_CATEGORIES } from "../../api/apiList";
import { debounce, isEmpty } from "lodash";
import Loader from "../../components/common/loader";
import { ToastContainer } from "react-toastify";
import { Breadcrumb, Modal } from "reactstrap";
import Login from "../Login/component";
import EmptyPage from "../EmptyPage/component";
import { updateCartItem } from "../../slices/catalogSlice";
import pincodelocation from "./pincode-location.json";
import { getDistance, isStoreOpen, handleAddToCart } from "../../components/common/utils";
import "./styles.scss";
import { notify } from "../../components/common/utils";
import StoretimingModal from "../../components/common/StoreTimingModal";
import Pagination from "react-bootstrap/Pagination";
import NoProductFound from "../../images/v2-images/no-product-found.svg";
import qcBanner from "../../images/home/qz-banner.png";
import qcBannerMobile from "../../images/home/qz-banner-mobile.png";
import axios from "axios";
import { Helmet } from "react-helmet";
import PageHeader from "../SellerPage/page-header";
import StoresCategorySlider from "../SellerPage/stores-category-slider";
import FilterSection from "../SellerPage/filter-section";
import ProductCard from "../../components/common/product-card";
import Footer from "../../components/common/Footer";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-creative';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCreative } from 'swiper/modules';
import All from "../../images/All-catagory.png";
import searchedProducts from "../../images/Ellipse 3674.png";
import { GET_BUYER_APP_SETTINGS } from "../../api/apiList";
import { setNavigator } from "../../api/navigation";
import MobileAddCart from "../../components/common/mobile-add-cart/index";
import NxtTwoBtn from "../../images/home/next-two-btn.svg";
import NxtOneBtn from "../../images/home/next-one-btn.svg";

let sortValue = -1;
let cancelToken;
const SellerComponent = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [locations, setLocation] = useState("");
  const [error, setError] = useState(null);
  const [catalogues, setCatalogues] = useState([])
  const [catalogueStatus, setCatalogueStatus] = useState("")
  const [showPreLoginAddessModal, setShowPreLoginAddessModal] = useState(false)
  const [catalogueCount, setCatalogueCount] = useState(0);
  const cartItems = useSelector((s) => s.catalog.cartItems);
  const [pincodelocations, setPincodeLocation] = useState([])
  const [pincode, setPincode] = useState("")
  const [page, setPage] = useState(1);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [newPincode, setNewPincode] = useState("")
  const [catalogDataTemp, setCatalogDataTemp] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [storeDetails, setStoreDetail] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const [selectedSubcategory, setSelectedSubcategory] = useState("All");
  const [storeTiming, setStoreTiming] = useState(false);
  const [sellerDetails, setSellerDetails] = useState({});
  const [searchVoiceText, setSearchVoiceText] = useState("");
  const [isInitialCallApi, setInitialCallApi] = useState(true);
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [loading, setLoading] = useState(false);
  const [isCalledApi, setIsCalledApi] = useState(false);
  const [activeCatalogsCategories, setActiveCatalogsCategories] = useState([]);
  const footerRef = useRef(null);
  const [isHeaderHide, setIsHeaderHide] = useState(false);
  const [qcImages, setQcImages] = useState([]);
  const limit = 120;
  const pageCount = Math.ceil(catalogueCount / limit)
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, catalogueCount);
  const [scrollTo, setScrollTo] = useState("");
  const catalogsRef = useRef(null);

  const validatePincode = async (pin) => {
    const pincodeRegex = /^\d{6}$/; // Regex to match exactly 6 digits
    if (!pin) {
      return "Please enter a pincode";
    } else if (!pincodeRegex.test(pin)) {
      return "Please enter a valid 6-digit pincode";
    }
    return "";
  };

  const handlePincodeChange = (e) => {
    const inputPin = e?.target?.value;
    setPincode(inputPin);
  };

  const findCoordinates = async () => {
    const errorMessage = await validatePincode(pincode);
    setError(errorMessage);
    if (errorMessage.length !== 0) {
      return
    }
    setLoading(true)
    const apiUrl = `https://nominatim.openstreetmap.org/search?postalcode=${pincode}&format=json`;
    fetch(apiUrl)
      .then((response) => response.json())
      .then(async(data) => {
        if (data.length > 0) {
          const { lat, lon } = data[0];
          const defaultAddress = {
            latitude: lat,
            longitude: lon,
            zipcode: pincode
          }
          localStorage.setItem('defaultAddress', JSON.stringify(defaultAddress));
          localStorage.setItem('locations', JSON.stringify(`${lat},${lon}`));
          setLocation(`${lat},${lon}`)
          setCatalogueStatus("loading")
          setPincode(pincode)
          getCataloguesForQuickCommerce({
            pincode: pincode,
            location: locations,
            subCategoryId: "All",
            page: page,
            sortValue: sortValue,
          });
          setLoading(false)
        } else {
          const options = {
              method: "post",
              url: `${process.env.REACT_APP_KIKO_API_BASE_URL_v3}/api/v1/maps/autocomplete-v2-ola`,
              headers: {
              // Authorization: `${token}`,
              desktop: true,
              },
              data: { search: pincode, token: "" },
          };
          const res = await axios(options);
          if (res?.data?.success) {

          const { lat, lng } = res?.data?.data[0]?.geometry?.location;
           const defaultAddress = {
            latitude: lat,
            longitude: lng,
            zipcode: pincode
          }
          localStorage.setItem('defaultAddress', JSON.stringify(defaultAddress));
          localStorage.setItem('locations', JSON.stringify(`${lat},${lng}`));
          setLocation(`${lat},${lng}`)
          setCatalogueStatus("loading")
          setPincode(pincode)
          getCataloguesForQuickCommerce({
            pincode: pincode,
            location: locations,
            subCategoryId: "All",
            page: page,
            sortValue: sortValue,
          });
          setLoading(false)
        }else{
          setError("No coordinates found for the provided pincode.")
          setLoading(false)
        }
        }
      })
      .catch((error) => {
        setError("Error fetching coordinates")
        console.error('Error fetching coordinates:', error);
      });
  };

  const getCataloguesForQuickCommerce = async (payload) => {
    setCatalogueStatus("loading")
    const url = `${process.env.REACT_APP_KIKO_API_BASE_URL_V2}/get-catalogue-for-quick-commerce`;
    const data = payload;
    const headers = {
      'Content-Type': 'application/json',
    };
    try {
      const response = await axios.post(url, data, { headers });
      if (response.data?.success) {
        localStorage.setItem("sellerDetails", JSON.stringify(response?.data?.data?.sellerData[0]))
        setCatalogueCount(response?.data?.data?.catalogueCount)
        if (page > 1) {
          setCatalogues([...catalogues, ...response?.data?.data?.results]);
        } else {
          setCatalogues(response?.data?.data?.results);
        }
        setSellerDetails(response?.data?.data?.sellerData[0])
        setActiveCatalogsCategories(response?.data?.data?.activeCategories)
        const sellerDetails = response?.data?.data?.sellerData[0]
        const sellerLocation = sellerDetails?.locations[0]?.gps?.split(",");
        const sellerLat = parseFloat(sellerLocation?.[0]);
        const sellerLon = parseFloat(sellerLocation?.[1]);
        let longData = await pincodelocations?.find((pin) => pin?.pincode == payload?.pincode)
        const defaultLat = parseFloat(longData?.location?.lat);
        const defaultLon = parseFloat(longData?.location?.lng);
        const dist = await getDistance(defaultLat, defaultLon, sellerLat, sellerLon);
        setIsOpen(isStoreOpen(response?.data?.data?.sellerData[0]));
        setShowPreLoginAddessModal(false)
        setCatalogueStatus("")
      } else {
        navigate("/")
      }
    } catch (error) {
      if (error.response) {
        console.error('Status:', error.response.status);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
    }
  }

  useEffect(() => {
    catalogs(false);
  }, [cartItems]);

  const getPincodeData = async () => {
    const url = `${process.env.REACT_APP_KIKO_API_BASE_URL_V2}/get-pincode-locations`;
    const headers = {
      'Content-Type': 'application/json',
    };
    try {
      const response = await axios.get(url, { headers });
      if (response.data) {
        setPincodeLocation(response.data)
      }
    } catch (error) {

    }
  }

  useEffect(() => {
    setNavigator(navigate);
    const fetchQCImages = async () => {
      try {
        const res = await API2.get(GET_BUYER_APP_SETTINGS);
        if (res?.data) {
          setQcImages(res.data?.qcBanners);
        }
      } catch (error) {
        console.error("ERROR BuyerAPPSettings: ", error);
      } finally {
      }
    };
    fetchQCImages();
  }, []);

  useEffect(() => {
    if (!isCalledApi) {
      localStorage.setItem("landingSource", `${process.env.REACT_APP_LANDING_SOURCE}`)
      getPincodeData()
      setTimeout(() => {
        if (localStorage.getItem("locations")) {
          try {
            const defAddress = localStorage.getItem("defaultAddress")
            const defLocations = localStorage.getItem("locations")
            const defZipcode = defAddress && JSON.parse(defAddress)?.zipcode
            const defLoc = JSON.parse(defLocations)
            setLocation(defLoc)
            setPincode(defZipcode);
          } catch (error) {
            setShowPreLoginAddessModal(true)
          }
        } else {
          setShowPreLoginAddessModal(true)
        }
      }, 500)
    }
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsHeaderHide(true);
      } else {
        setIsHeaderHide(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const getQueryParams = (queryString) => {
    return new URLSearchParams(queryString);
  };
  const queryParams = getQueryParams(location.search);
  const slug = queryParams.get("pid");
  const encodedValue = encodeURIComponent(slug);
  localStorage.setItem("slug", `/seller?pid=${encodedValue}`);

  const getCategoriesData = async () => {
    try {
      const response = await API2.post(GET_CATEGORIES);
      if (response.data) {
        const selectedCategory = response?.data?.data
        const groceryCategories = selectedCategory.find(item => item.title === "Grocery")
        const filteredCategories = groceryCategories?.subCategories?.filter(
          (cat) =>
            activeCatalogsCategories.includes(cat.title)
        );
        setCategoriesData(filteredCategories);
      }
    } catch (error) {
      console.log("HOME : ERROR CATEGORIES ", error);
    }
  };

  useEffect(() => {
    if (locations && !isCalledApi) {
      setIsCalledApi(true)
      localStorage?.removeItem("sellerDetails")
      getCategoriesData()
      setCatalogDataTemp([]);
      getCataloguesForQuickCommerce({
        pincode: pincode,
        location: locations,
        subCategoryId: "All",
        page: page,
        sortValue: sortValue,
      });
    }
  }, [locations]);

  useEffect(() => {
    getCategoriesData()
  }, [activeCatalogsCategories]);

  useEffect(() => {
    if (catalogues?.length < 1 && isInitialCallApi && locations) {
    } else {
      catalogs(true);
    }
  }, [catalogues]);

  useEffect(() => {
    setStoreDetail(sellerDetails);
    setPage(1);
  }, [catalogueCount]);

  useLayoutEffect(() => {
    if (scrollTo === 'catalogSection') {
      const scrollToSection = () => {
        if (catalogsRef.current) {
          const observer = new MutationObserver(() => {
            if (catalogsRef.current) {
              catalogsRef.current.scrollIntoView({ behavior: 'smooth' });
              const top = catalogsRef.current.getBoundingClientRect().top + window.scrollY - 80;
              window.scrollTo({ top, behavior: 'smooth' });
              observer.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          return () => observer.disconnect();
        } else {
          requestAnimationFrame(scrollToSection);
        }
      };
      scrollToSection();
      setScrollTo("")
    }
  }, [scrollTo]);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (!footerRef.current) return;
  //     const footerTop = footerRef.current.getBoundingClientRect().top;
  //     const windowHeight = window.innerHeight;
  //     if (footerTop <= windowHeight + 100) {
  //       const pageCount = Math.ceil(catalogueCount / 20);
  //       if (page < pageCount && catalogueStatus !== "loading") {
  //         setScrollLoading(true)
  //         fetchNextPage();
  //       }
  //     }
  //   };
  //   const debouncedHandleScroll = debounce(handleScroll, 200);
  //   window.addEventListener("scroll", debouncedHandleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", debouncedHandleScroll);
  //   };
  // }, [page, catalogueStatus, catalogueCount]);

  const fetchNextPage = (currPage) => {
    setScrollTo("catalogSection")
    if (page === currPage) {
      return
    }
    getCataloguesForQuickCommerce({
      pincode: pincode,
      location: locations,
      subCategoryId: selectedSubcategory,
      page: currPage,
      sortValue: sortValue,
      search: searchVoiceText ? searchVoiceText : searchText,
    });
    setPage(currPage);
    setScrollLoading(false)
  };

  const handleSortChange = (value) => {
    if (value === "PriceLowToHigh") {
      sortValue = 0;
    } else if (value === "PriceHighToLow") {
      sortValue = 1;
    } else {
      sortValue = -1;
    }
    setCatalogues([])
    setCatalogDataTemp([]);
    setPage(1)
    getCataloguesForQuickCommerce({
      pincode: pincode,
      location: locations,
      subCategoryId: selectedSubcategory,
      page: 1,
      sortValue: sortValue,
    });
  };

  const onResetSearch = () => {
    setSearchText("")
    setSelectedSubcategory("All")
    optimizedUserFn()
  }

  const handleSubcategoryClick = (subcategory) => {
    if (subcategory !== selectedSubcategory) {
      setCatalogues([])
      setSelectedSubcategory(subcategory);
      setSearchText("");
      document?.addEventListener("DOMContentLoaded", () => {
        let searchInput = document?.getElementById("searchInput");
        if (searchInput) {
          searchInput.value = "";
        }
      });
      setCatalogDataTemp([]);
      setPage(1)
      getCataloguesForQuickCommerce({
        location: locations,
        pincode: pincode,
        subCategoryId: subcategory,
        page: 1,
        sortValue: sortValue,
      });
    }
  };

  const catalogs = (isFromScroll) => {
    if (!catalogues) {
      return;
    }
    let temp = catalogDataTemp;
    // const newData = isFromScroll
    //   ? catalogues.filter((item) => !temp.some((existingItem) => existingItem._id === item._id))
    //   : catalogues;
    // const tempData = isFromScroll ? temp.concat(newData) : temp;
    const newData = catalogues;
    const tempData = newData;
    setCatalogDataTemp([]);
    const data = tempData.map((data) => {
      const index = cartItems?.findIndex((item) => item?._id === data?._id);
      if (index !== -1) {
        return { ...data, quantity: cartItems[index].quantity };
      } else {
        return { ...data, quantity: 1 };
      }
    });
    setCatalogDataTemp([...data]);
  };

  const updateCartItemQuantity = (itemId, newQuantity, singleCatalogData) => {
    const itemIndex = cartItems?.findIndex((item) => item._id === itemId);
    if (newQuantity > parseInt(singleCatalogData?.availableQuantity)) {
      notify(
        "success",
        "Available Quantity is only " + singleCatalogData?.availableQuantity
      );
    } else if (newQuantity > parseInt(singleCatalogData?.maximumQuantity)) {
      notify(
        "success",
        `Maximum quantity available is ${singleCatalogData?.maximumQuantity} for this product`
      );
    } else {
      let updatedCartItems;
      if (itemIndex !== -1) {
        updatedCartItems = cartItems?.map((item, index) =>
          index === itemIndex ? { ...item, quantity: newQuantity } : item
        );
        if (newQuantity === 0) {
          updatedCartItems = updatedCartItems.filter(
            (item) => item._id !== itemId
          );
        }
      } else {
        if (newQuantity !== 0) {
          const newCartItem = {
            _id: singleCatalogData._id,
            productId: singleCatalogData.productId,
            quantity: newQuantity,
            catalogData: singleCatalogData,
          };
          updatedCartItems = [...cartItems, newCartItem];

        } else {
          updatedCartItems = [...cartItems];
        }
      }
      const cartStorage = JSON.parse(localStorage.getItem("cart")) || [];
      const existingProviderId = cartStorage?.[0]?.catalogData?.providerId;
      if (existingProviderId && updatedCartItems?.some(item => item?.catalogData?.providerId !== existingProviderId)) {
        notify("error", "You can add items from a single store at a time.");
      }
      else {
        // if (localStorage.getItem("landingSource")?.includes("qc") && typeof fbq === 'function') {
        //   fbq('track', 'AddToCart', {
        //     content_name: singleCatalogData.productName,
        //     content_ids: singleCatalogData._id,
        //     value: singleCatalogData.price
        //       ? parseFloat(singleCatalogData.price)
        //       : 0,
        //     currency: 'INR',
        //   });
        // }
        handleAddToCart(
          singleCatalogData.productName,
          singleCatalogData._id,
          singleCatalogData.category,
          newQuantity,
          singleCatalogData.price,
          storeDetails.name
        );
        localStorage.setItem("cart", JSON.stringify(updatedCartItems));
        dispatch(updateCartItem(updatedCartItems));
      }
    }
  };

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setVariant = (variantId, data) => {
    if (variantId) {
      const singleVariant = data?.variants.find((item) => {
        return item?._id === variantId;
      });
      const index = cartItems?.findIndex((item) => item?._id === variantId);
      const tempCatalogs = catalogDataTemp.map((catalog) => {
        if (catalog?._id === data?._id) {
          return {
            ...catalog,
            _id: singleVariant?._id,
            productName: singleVariant?.productName,
            productImages: singleVariant?.productImages,
            weight: singleVariant?.weight,
            weightUnit: singleVariant?.weightUnit,
            price: singleVariant?.price,
            maximumPrice: singleVariant?.maximumPrice,
            quantity: index !== -1 ? cartItems[index].quantity : 1,
          };
        } else {
          return { ...catalog };
        }
      });
      setCatalogDataTemp(tempCatalogs);
    }
  };

  useEffect(() => {
    if (newPincode) {
      getCataloguesForQuickCommerce({
        pincode: newPincode,
        location: JSON.parse(localStorage?.getItem("locations")),
        subCategoryId: selectedSubcategory,
        page: 1,
        sortValue: sortValue,
        search: searchText,
      });
    }
  }, [newPincode])

  const updatedCategories = useMemo(() => {
    const list = [];
    if (searchText.trim() !== "") {
      list.push({ title: "Searched Products", imgUrl: searchedProducts });
    }
    list.push({ title: "All", imgUrl: All });
    return [...list, ...categoriesData];
  })

  const debounce_search = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const callSearchApi = async (e = "") => {
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    let searchText;
    if (typeof e === "string") {
      searchText = e;
      setSearchVoiceText(e);
    } else {
      searchText = e?.target?.value;
    }
    cancelToken = axios.CancelToken.source();
    if (searchText && searchText != "") {
      setPage(1)
      setCatalogDataTemp([]);
      setCatalogues([])
      if (localStorage?.getItem("locations")) {
        getCataloguesForQuickCommerce({
          pincode: JSON.parse(localStorage?.getItem("defaultAddress"))?.zipcode,
          location: JSON.parse(localStorage?.getItem("locations")),
          subCategoryId: selectedSubcategory,
          page: 1,
          sortValue: sortValue,
          search: searchText,
        });
      }
    } else {
      getCataloguesForQuickCommerce({
        pincode: JSON.parse(localStorage?.getItem("defaultAddress"))?.zipcode,
        location: JSON.parse(localStorage?.getItem("locations")),
        subCategoryId: "All",
        page: 1,
        sortValue: sortValue,
        search: "",
      });
    }
  };
  const optimizedUserFn = useCallback(debounce_search(callSearchApi), []);

  let active = 2;
  let items = [];
  for (let number = 1; number <= 5; number++) {
    items.push(
      <Pagination.Item key={number} active={number === active}>
        {number}
      </Pagination.Item>
    );
  }

  const handleSearchInput = (e) => {
    optimizedUserFn(e);
    if (e.target.value) {
      setSearchText(e.target.value);
      setSelectedSubcategory("Searched Products")
    }
    else {
      setSearchText("")
      setSelectedSubcategory("All")
    }
  }
  useEffect(() => {
    if (
      // true
      process.env.REACT_APP_NODE_ENV === "production" &&
      typeof window !== "undefined" &&
      localStorage.getItem("landingSource")?.includes("qc")
    ) {
      // console.log('enter micro')
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "rmdzrne549");
    }
  }, []);

  const renderPagination = () => {
    const pages = [];
    if (pageCount <= 7) {
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (page > 4) {
        pages.push("...");
      }
      const start = Math.max(2, page - 1);
      const end = Math.min(pageCount - 1, page + 1);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (page < pageCount - 3) {
        pages.push("...");
      }
      pages.push(pageCount);
    }
    return pages.map((p, i) => (
      <li
        key={i}
        className={`pagination-items pageNumber ${p === page ? "active" : ""}`}
      >
        {p === "..." ? (
          <div className="pagination-ellipsis">...</div>
        ) : (
          <div
            onClick={() => fetchNextPage(Number(p))}
            className="pagination-link"
          >
            {p}
          </div>
        )}
      </li>
    ));
  };

  return (
    <>
      {process.env.REACT_APP_NODE_ENV === "production" && localStorage.getItem("landingSource")?.includes("qc") && (
        <Helmet>
          <script>
            {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '326242339368504');
          fbq('track', 'PageView');`}
          </script>
          <noscript>
            {`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=326242339368504&ev=PageView&noscript=1"/>`}
          </noscript>
        </Helmet>
      )}
      {/* {process.env.REACT_APP_NODE_ENV === "production" && localStorage.getItem("landingSource")?.includes("qc") && (
        <Helmet>
         <script type="text/javascript">
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "rmdzrne549");
</script>

        </Helmet>
      )} */}
      {isEmpty(sellerDetails) && catalogueStatus === "loading" ? <Loader /> : (
        <>
          {isEmpty(sellerDetails) && catalogueStatus === "loading" ? (
            <Loader />
          ) : !isEmpty(sellerDetails) && (
            <>
              <ToastContainer
                autoClose={300}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <Header hide={isHeaderHide} title={sellerDetails?.name} />
              <div className="mobile-secondary-header-kl seller-mobile-header">
                <div className="mobile-secondary-header-inner-kl">
                  <div
                    className="buyer-pin-code-mobile-kl"
                  >
                    <PageHeader sellerDetails={sellerDetails} isOpen={isOpen} setStoreTiming={setStoreTiming} />
                  </div>
                </div>
              </div>
              <div className="category-my-carousel">
                <Swiper
                  modules={[Navigation, EffectCreative]}
                  className="circular-slider"
                  loop={false}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={3}
                  effect="creative"
                  creativeEffect={{
                    perspective: true,
                    limitProgress: 3,
                    prev: {
                      translate: ['-100%', '-35%', -180],
                      rotate: [0, 0, -0],
                      origin: "top"
                    },
                    next: {
                      translate: ['100%', '-35%', -180],
                      rotate: [0, 0, 0],
                      origin: "top"
                    },
                  }}
                >
                  {updatedCategories.map((category, index) => (
                    <SwiperSlide key={index} >
                      <div onClick={() => {
                        handleSubcategoryClick(category.title)
                      }
                      } className={`category-slide ${selectedSubcategory === category.title ? "swiper-active" : ""}`}>
                        <div className="category-image-wrapper">
                          <img
                            src={category.imgUrl}
                            alt={category.title}
                            className="category-image"
                          />
                        </div>
                        <span className="category-name">{category.title}</span>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="category-section-kl">
                <div className="category-section-inner-kl">
                  <Breadcrumb category={searchParams.get("category")} sellerDetails={sellerDetails} />
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <PageHeader sellerDetails={sellerDetails} isOpen={isOpen} setStoreTiming={setStoreTiming} />
                      </div>
                    </div>
                  </div>
                  <section className="seller-category-slider-kl">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <StoresCategorySlider isHomePage={false} activeCategory={selectedSubcategory} categoriesData={categoriesData} navigate={navigate} handleSubcategoryClick={handleSubcategoryClick} goToTop={goToTop} searchText={searchText} />
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* <section className="qz-banner-section">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <img
                            src={qcImages?.desktop?.[0]?.value ? qcImages?.desktop?.[0]?.value : qcBanner}
                            alt=""
                            className="qc-banner-image qc-banner-image-desktop"
                          />
                          <img
                            src={qcImages?.mobile?.[0]?.value ? qcImages?.mobile?.[0]?.value : qcBannerMobile}
                            alt=""
                            className="qc-banner-image qc-banner-image-mobile"
                          />
                        </div>
                      </div>
                    </div>
                  </section> */}
                  <div className="container" ref={catalogsRef}>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <FilterSection selectedSubcategory={selectedSubcategory} catalogueCount={catalogueCount} handleSortChange={handleSortChange} handleSearchInput={handleSearchInput} searchText={searchText} onResetSearch={onResetSearch} />
                      </div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        {catalogDataTemp?.length === 0 || catalogueStatus === "loading" ? (
                          <div className="stores-list-container">
                            {catalogueStatus === "loading" ? (
                              <Loader />
                            ) : (
                              <EmptyPage
                                image={NoProductFound}
                                EmptySubTitle="No Product Found !"
                                altText=""
                              />
                            )}
                          </div>
                        ) :
                          <div className="product-card-container-kl">
                            <>
                              {catalogDataTemp.map((item, index) => (
                                <ProductCard
                                  key={index}
                                  data={item}
                                  catalogDataTemp={catalogDataTemp}
                                  navigate={navigate}
                                  setVariant={setVariant}
                                  updateCartItemQuantity={updateCartItemQuantity}
                                  cartItems={cartItems}
                                />
                              ))}
                            </>
                          </div>}
                        {/* <div className="seller-loader">
                          {(catalogueStatus === "loading") && (
                            <Loader />
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {(catalogDataTemp?.length > 0 && catalogueCount > limit) &&
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                        <div className="pagination-container">
                          <ul className="pagination-list">
                            <li className="pagination-items">
                              <div onClick={(e) => fetchNextPage(page - 1)} className={`pagination-link prev-arrow ${page > 1 ? "" : "pagination-disabled"}`} >
                                <img src={NxtOneBtn} alt="prev" />
                              </div>
                              <div onClick={(e) => fetchNextPage(page - 2)} className={`pagination-link prev-arrow ${page > 2 ? "" : "pagination-disabled"}`} >
                                <img src={NxtTwoBtn} alt="prev" />
                              </div>
                            </li>
                            {renderPagination()}
                            <li className="pagination-items">
                              <div onClick={(e) => fetchNextPage(page + 1)} className={`pagination-link next ${page >= pageCount ? "pagination-disabled" : ""}`} >
                                <img src={NxtOneBtn} alt="Next" />
                              </div>
                              <div onClick={(e) => fetchNextPage(page + 2)} className={`pagination-link next ${page >= pageCount - 1 ? "pagination-disabled" : ""}`} >
                                <img src={NxtTwoBtn} alt="Next" />
                              </div>
                            </li>
                          </ul>
                          <div className="pagination-showing-items">
                            {`Showing ${start}-${end} of ${catalogueCount} items`}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div ref={footerRef}>
                <Footer />
              </div>
              {modalIsOpen && (
                <Login
                  isOpenFromCart={false}
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setModalIsOpen}
                ></Login>
              )}
              <StoretimingModal
                isOpen={storeTiming}
                toggle={() => setStoreTiming(!storeTiming)}
                storeTimings={sellerDetails}
              />
            </>
          )}
        </>
      )}
      <Modal
        isOpen={showPreLoginAddessModal}
        aria-labelledby="contained-modal-title-vcenter"
        contentLabel="Address Modal"
        centered
        className="custom-modal-kl"
      >
        <div className="custom-modal-header-kl">
          <div className="custom-modal-title-kl">Enter Your Pincode</div>
          {
            defaultAddress &&
            <button
              type="button"
              className="close-icon-kl"
              onClick={() => {
                setShowPreLoginAddessModal(false);
              }}>
            </button>
          }
        </div>
        <div className="custom-modal-body-kl">
          <div className="addressmodal-block-kl">
            <input
              type="text"
              placeholder="Enter your pincode"
              value={pincode}
              onChange={(e) => handlePincodeChange(e)}
              maxLength={6}
              className="form-control"
            />
            {error?.length > 0 &&
              <p className="error">{error}</p>
            }
            <button
              className="pin-code-enter-btn w-100"
              type="button"
              onClick={findCoordinates}
              disabled={loading}
              style={{ marginBottom: '0px' }}
            >
              {loading ? "Please Wait" : "Submit"}
            </button>
          </div>
        </div>
      </Modal>
      <MobileAddCart itemCount={cartItems?.length} />
    </>
  );
};

export default SellerComponent;
